import {useEffect, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {toCamelCase} from '@s-ui/js/lib/string'
import AtomCheckbox from '@s-ui/react-atom-checkbox'
import {useDelayToNextFrame} from '@adv-mt/mt-hook-use-delay-to-next-frame'

const BASE_TEST_ID = 'body-type-item'

const mapLabelWith = separator => label => label.replace(' ', separator).toLowerCase()

const FormBodyTypeItem = ({id, isSelected = false, label, onChange = () => {}}) => {
  const [isChecked, setIsChecked] = useState(isSelected)

  const delayToNextFrame = useDelayToNextFrame()

  useEffect(() => {
    if (isSelected !== isChecked) {
      setIsChecked(isSelected)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected])

  const checkboxId = `${mapLabelWith('_')(label)}_${id}`
  const textClassNames = cx('mt-FormBodyType-itemText', isChecked && `is-selected`)
  const labelClassName = cx(
    'mt-FormBodyType-item',
    `mt-FormBodyType-item--${toCamelCase(label)}`,
    isChecked && `is-selected`
  )

  const _handleOnChange = e => {
    setIsChecked(!isChecked)
    delayToNextFrame(() => {
      onChange(e, {value: id})
    })
  }

  return (
    <>
      <label htmlFor={checkboxId} className={labelClassName} data-testid={BASE_TEST_ID}>
        <AtomCheckbox id={checkboxId} checked={isChecked} isNative onChange={_handleOnChange} />
        <span className={textClassNames}>{label}</span>
      </label>
    </>
  )
}

FormBodyTypeItem.propTypes = {
  id: PropTypes.number.isRequired,
  isSelected: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func
}

export default FormBodyTypeItem
